import * as d3 from 'd3';
import { IScaleBase } from './IScaleBase';

export class LinearScale implements IScaleBase {
    private _scale: d3.scale.Linear<any, any>;
    private _min: number;
    private _max: number;

    constructor(min, max) {
        this._min = min;
        this._max = max;
        this.init();
    }

    private init() {
        this._scale = d3.scale.linear()
            .domain([this._min, this._max]);
    }

    update(min: number, max: number) {
        this._min = min;
        this._max = max;
        this._scale.domain([min, max]);
    }

    isUpdated(min: number, max: number): boolean {
        return this._min === min && this._max === max;
    }

    scale(): d3.scale.Linear<any, any> {
        return this._scale;
    }
}